/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CategoryWithFamilyResource } from './';
import {
    CategoryWithFamilyResourceFromJSON,
    CategoryWithFamilyResourceFromJSONTyped,
    CategoryWithFamilyResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateCategoriesRequest
 */
export interface UpdateCategoriesRequest {
    /**
     * 
     * @type {CategoryWithFamilyResource}
     * @memberof UpdateCategoriesRequest
     */
    preferredCategory: CategoryWithFamilyResource;
    /**
     * 
     * @type {Array<CategoryWithFamilyResource>}
     * @memberof UpdateCategoriesRequest
     */
    categories: Array<CategoryWithFamilyResource>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCategoriesRequest
     */
    selectedByPredictions: boolean;
}

/**
 * Check if a given object implements the UpdateCategoriesRequest interface.
 */
export function instanceOfUpdateCategoriesRequest(value: object): value is UpdateCategoriesRequest {
    if (!('preferredCategory' in value) || value['preferredCategory'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('selectedByPredictions' in value) || value['selectedByPredictions'] === undefined) return false;
    return true;
}

export function UpdateCategoriesRequestFromJSON(json: any): UpdateCategoriesRequest {
    return UpdateCategoriesRequestFromJSONTyped(json, false);
}

export function UpdateCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCategoriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredCategory': CategoryWithFamilyResourceFromJSON(json['preferredCategory']),
        'categories': ((json['categories'] as Array<any>).map(CategoryWithFamilyResourceFromJSON)),
        'selectedByPredictions': json['selectedByPredictions'],
    };
}

export function UpdateCategoriesRequestToJSON(value?: UpdateCategoriesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'preferredCategory': CategoryWithFamilyResourceToJSON(value['preferredCategory']),
        'categories': ((value['categories'] as Array<any>).map((v) => CategoryWithFamilyResourceToJSON(v))),
        'selectedByPredictions': value['selectedByPredictions'],
    };
}

